import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'

// element-ui component
import { Dialog, Upload } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import VueCompositionAPI from '@vue/composition-api'

import OtpInput from '@bachdgvn/vue-otp-input'
import i18n from '@/libs/i18n'
import router from './router'
import store from './store'
import App from './App.vue'

// Global function
import './common'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/clipboard'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'
import '@/libs/tour'

// Axios Mock Adapter
import '@/@fake-db/db'


import excel from 'vue-excel-export'
import ToggleButton from 'vue-js-toggle-button'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDKZu_g3hJArecjslipZrqbRsaJYYyx7eI',
    libraries: 'places',
  }
});

Vue.use(ToggleButton)

Vue.use(excel)
// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// element-ui component
// configure language
locale.use(lang)
// import components
Vue.component(Dialog.name, Dialog)
Vue.component(Upload.name, Upload)

// Composition API
Vue.use(VueCompositionAPI)

// vue-otp-input
Vue.component('v-otp-input', OtpInput)

// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css') // For form-wizard

// import kanit font
require('@core/assets/fonts/kanit/stylesheet.css')

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
